"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _getResource = require("../../utilities/getResource");
var _excluded = ["classes", "title", "buttons", "contentText", "onClose", "onConfirm", "buttonType", "userEmail", "userFirstName", "userLastName", "resources", "language"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      minWidth: '150px'
    },
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '40rem',
      minHeight: '20rem',
      maxWidth: '80% !important'
    },
    dialogContentRoot: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
var AssessmentAgreement = /*#__PURE__*/function (_Component) {
  function AssessmentAgreement(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AssessmentAgreement);
    _this = _callSuper(this, AssessmentAgreement, [props]);
    _this.state = {
      name: '',
      description: '',
      userFullScroll: false,
      userFirstName: '',
      userLastName: '',
      disableConfirm: true,
      touCheckbox: false
    };
    ['handleValidationCheck', 'handleFirstNameInput', 'handleLastNameInput', 'handleTOUCheckbox', 'handleScroll'].forEach(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(AssessmentAgreement, _Component);
  return (0, _createClass2["default"])(AssessmentAgreement, [{
    key: "handleFirstNameInput",
    value: function handleFirstNameInput(e) {
      this.setState({
        userFirstName: e.target.value
      }, function () {
        this.handleValidationCheck();
      });
    }
  }, {
    key: "handleLastNameInput",
    value: function handleLastNameInput(e) {
      this.setState({
        userLastName: e.target.value
      }, function () {
        this.handleValidationCheck();
      });
    }
  }, {
    key: "handleTOUCheckbox",
    value: function handleTOUCheckbox(e) {
      this.setState({
        touCheckbox: e.target.checked
      }, function () {
        this.handleValidationCheck();
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      var bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      if (bottom) {
        this.setState({
          userFullScroll: true
        });
      }
    }
  }, {
    key: "handleValidationCheck",
    value: function handleValidationCheck() {
      if (this.state.userFirstName !== '' && this.state.userLastName !== '' !== false && this.state.touCheckbox) {
        this.setState({
          disableConfirm: false
        });
        return;
      }
      this.setState({
        disableConfirm: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        buttons = _this$props.buttons,
        contentText = _this$props.contentText,
        onClose = _this$props.onClose,
        onConfirm = _this$props.onConfirm,
        buttonType = _this$props.buttonType,
        userEmail = _this$props.userEmail,
        userFirstName = _this$props.userFirstName,
        userLastName = _this$props.userLastName,
        resources = _this$props.resources,
        language = _this$props.language,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        fullWidth: true,
        onClose: onClose,
        "aria-labelledby": "simple-dialog-title"
      }, other), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
        onScroll: this.handleScroll
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, null, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: (0, _getResource.getResource)(resources, language, 'msgTermsOfUse2025', '')
        }
      }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
        sx: {
          maxWidth: "400px",
          width: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _getResource.getResource)(resources, language, 'Label', 'Email')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        sx: {
          marginBottom: "10px"
        },
        fullWidth: true,
        key: "email",
        margin: "dense",
        name: "email",
        value: this.props.userProp.email,
        disabled: true
      }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _getResource.getResource)(resources, language, 'Label', 'First Name')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        sx: {
          marginBottom: "10px"
        },
        fullWidth: true,
        key: "firstName",
        margin: "dense",
        name: "firstName",
        onBlur: this.handleFirstNameInput
      }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _getResource.getResource)(resources, language, 'Label', 'Last Name')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        sx: {
          marginBottom: "10px"
        },
        fullWidth: true,
        key: "lastName",
        margin: "dense",
        name: "lastName",
        onBlur: this.handleLastNameInput
      })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        onChange: this.handleTOUCheckbox
      }), (0, _getResource.getResource)(resources, language, 'msgTermsOfUse2025-checkbox', '')))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, buttons !== 'confirm-only' && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onClose();
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Decline')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        type: buttonType,
        form: "theForm",
        variant: "contained",
        color: "primary",
        disabled: this.state.disableConfirm,
        className: classes.button,
        onClick: function onClick() {
          return onConfirm(_this2.props.surveyID, _this2.state.userFirstName, _this2.state.userLastName);
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Confirm'))));
    }
  }]);
}(_react.Component);
AssessmentAgreement.propTypes = {
  title: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onConfirm: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(AssessmentAgreement);